import { ReactElement } from 'react'
import { GridFooter, GridFooterContainer } from '@mui/x-data-grid-pro'
import { FormHelperText } from '@mui/material'

interface Props {
  helperText?: string
  error?: boolean
  errorMessage?: string
}

export const DataGridCustomFooter = ({ helperText, error, errorMessage }: Props): ReactElement => {
  return (
    <GridFooterContainer>
      {/* Left side: Error Message or Hint Text */}
      <div style={{ flex: 1, paddingLeft: 10 }}>
        {error && errorMessage && <FormHelperText error>{errorMessage}</FormHelperText>}
        {!error && helperText && <FormHelperText>{helperText}</FormHelperText>}
      </div>

      {/* Right side: Default Pagination / Footer controls */}
      <GridFooter />
    </GridFooterContainer>
  )
}
